/*
 * File: Clinical.tsx
 * Project: mp-mobile-app
 *
 * Created by Cole on 01/02/2020
 *
 * Copyright (c) 2021 MacPractice, Inc. All rights reserved.
 *
 * Description: Displays the clinical page.
 */
import React from "react";
import ClinicalList from "./ClinicalList";
import ClinicalToolbar from "./ClinicalToolbar";

const Clinical = () => (
  <div>
    <ClinicalToolbar />
    <ClinicalList />
  </div>
);

export default Clinical;
